import { FC, ReactElement } from 'react';

import { CustomSwiper, ICustomSwiperNavigationRef } from '../../CustomSwiper';
import { PROMOS_SWIPER_OPTIONS } from '../../../settings/promos';

interface IStandardCarouselProps {
  children: ReactElement[];
  navRef: ICustomSwiperNavigationRef;
}

export const PromoCarousel: FC<IStandardCarouselProps> = ({ children, navRef }) => (
  <CustomSwiper className="pik-promos-carousel" {...PROMOS_SWIPER_OPTIONS} navRef={navRef}>
    {children}
  </CustomSwiper>
);
